import {FleetAssetCapability, FleetAssetCapabilityEntity} from "../../../model/fleet-asset-capability";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type FleetAssetCapabilitySelectorProps = {};

export const fleetAssetCapabilitiesSelector = () => createSelector(
  [getUseQueryResultData<FleetAssetCapability[]>],
  (data) => {
    return selectFleetAssetCapabilitiesAndTransform(
      data ?? [], {}
    );
  }
);

export const fleetAssetCapabilityTypesSelector = () => createSelector(
  [getUseQueryResultData<FleetAssetCapability[]>],
  (data) => {
    const caps = selectFleetAssetCapabilitiesAndTransform(data ?? [], {});
    return new Set(caps.map(c => c.fleetCapabilityType))
  }
);

export const fleetAssetCapabilitySelector = () => createSelector(
  [getUseQueryResultData<FleetAssetCapability>],
  (data) => {
    return data ? transformFleetAssetCapability(data) : undefined;
  }
);

export const selectFleetAssetCapabilities = (values?: FleetAssetCapability[], selector?: FleetAssetCapabilitySelectorProps): FleetAssetCapability[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformFleetAssetCapability = (value: FleetAssetCapability): FleetAssetCapabilityEntity => {
  return FleetAssetCapabilityEntity.from(value)
}

export const selectFleetAssetCapabilitiesAndTransform = (values?: FleetAssetCapability[], selector?: FleetAssetCapabilitySelectorProps): FleetAssetCapabilityEntity[] => {
  const selected = selectFleetAssetCapabilities(values, selector);
  return selected.map(transformFleetAssetCapability);
};
